import { TextField } from "@mui/material";
import { normalizeDialogDate } from "./dialogDate";

export default function DialogDateField({ onChange, onBlur, ...props }) {
  return <TextField {...props} type="date" onChange={onChange} onBlur={event => {
    const normalized = normalizeDialogDate(event.target.value);
    if (normalized !== event.target.value) {
      event.target.value = normalized;
      onChange?.(event);
    }
    onBlur?.(event);
  }} />;
}
